var _circle, _path, _circle2, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLeft180 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: -33.999901,
    r: 25,
    transform: "rotate(90)",
    fill: "#000000",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "filled",
    d: "m 58.9999,34 c 0,-3.283 -0.6466,-6.5339 -1.903,-9.5671 C 55.8405,21.3998 53.999,18.6438 51.6776,16.3223 49.3561,14.00086 46.6001,12.15938 43.567,10.90301 40.5338,9.64664 37.283,9 33.9999,9 c -3.283,0 -6.5339,0.64664 -9.5671,1.90301 -3.0331,1.25637 -5.7891,3.09786 -8.1106,5.41929 -2.3214,2.3215 -4.1629,5.0775 -5.4193,8.1106 C 9.64655,27.4661 8.99991,30.717 8.99991,34 Z",
    fill: "#000000",
    fillOpacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: -33.999901,
    cy: -34,
    r: 4,
    transform: "scale(-1)",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 58.9999,34 c 0,-6.6304 -2.6339,-12.9893 -7.3223,-17.6777 C 46.9892,11.63392 40.6303,9 33.9999,9 27.3695,9 21.0107,11.63392 16.3222,16.3223 11.6338,21.0107 8.99991,27.3696 8.99991,34",
    stroke: "#000000",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 3,29.8081 9.57505,34.7423 16.1386,29.813",
    stroke: "#000000",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLeft180);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Left180.44a14622ae3775e505418f523a715050.svg";